import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import Env from 'Env';

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();

const connectionString = Env.getApplicationInsightsConnection();
// Only initialise App Insights when a real connection string is provided.
// In local dev the value may be a pipeline token placeholder or the 'TEST_CONNECTION_STRING'
// fallback — both are invalid and would cause the SDK to throw.
// charCodeAt: '#'=35, '{'=123. Avoids string literals that the replacetokens task could match.
const isTokenPlaceholder =
  connectionString && connectionString.charCodeAt(0) === 35 && connectionString.charCodeAt(1) === 123;
const isRealConnectionString = connectionString && !isTokenPlaceholder && connectionString !== 'TEST_CONNECTION_STRING';

const appInsights = isRealConnectionString
  ? new ApplicationInsights({
    config: {
      connectionString,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
      },
    },
  })
  : null;

if (appInsights) {
  appInsights.loadAppInsights();
}

/** @param {string} name @param {any} loggedInUser @param {string | undefined} topLevelAccount @param {Record<string, unknown>} [properties] */
export const trackPageView = (name, loggedInUser, topLevelAccount = undefined, properties = {}) => {
  if (!appInsights) return;
  appInsights.trackPageView({
    name,
    properties: {
      userId: loggedInUser.userId,
      userEmail: loggedInUser.emailId,
      userName: loggedInUser.givenName + ' ' + loggedInUser.familyName,
      impersonationUserId: loggedInUser?.userImpersonationInfo?.id,
      impersonationUserEmail: loggedInUser?.userImpersonationInfo?.emailId,
      topLevelAccount,
      ...properties,
    },
  });
};

/** @param {string} name @param {any} loggedInUser @param {string | undefined} topLevelAccount @param {string} description @param {Record<string, unknown>} [properties] */
export const trackCustomEvent = (name, loggedInUser, topLevelAccount = undefined, description, properties = {}) => {
  if (!appInsights) return;
  appInsights.trackEvent({
    name,
    properties: {
      userId: loggedInUser.userId,
      userEmail: loggedInUser.emailId,
      userName: loggedInUser.givenName + ' ' + loggedInUser.familyName,
      impersonationUserId: loggedInUser?.userImpersonationInfo?.id,
      impersonationUserEmail: loggedInUser?.userImpersonationInfo?.emailId,
      topLevelAccount,
      description,
      ...properties,
    },
  });
};

export { appInsights };
